const detailTableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial', },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '储量',
    dataIndex: 'value',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'value', },
  },
  {
    title: '国家',
    dataIndex: 'country',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'country', },
  },
  {
    title: '年份',
    dataIndex: 'year',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'year', },
  },
  {
    title: '备注',
    dataIndex: 'remark',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'remark', },
    // width: 200,
  },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action', },
    align: 'center',
    // width: 180,
  },
];

export {
  detailTableConfig,
};